// NavLink
import Icon from 'components/common/Icon';
import { Route } from 'config/routes';
import Link from 'next/link';
import React from 'react';
import styles from './NavLink.module.sass';
import cn from 'classnames';
import { useAuth } from 'hooks/useAuth';

export interface NavLinkProps {
  route: Required<Route>;
  active: boolean;
  onClose?: () => void;
  iconOnly?: boolean;
}

const NavLink: React.FC<NavLinkProps> = ({
  route: { getPath, icon, name, permissions },
  active,
  onClose,
  iconOnly,
}) => {
  const path = getPath();
  const { authProfile } = useAuth();

  if (permissions.length > 0) {
    if (typeof authProfile === 'undefined') {
      return null;
    } else if (
      authProfile.user.permissions.findIndex((permission) =>
        permissions.includes(permission)
      ) < 0
    ) {
      return null;
    }
  }

  return (
    (<Link
      href={path}
      passHref
      className={cn(styles.navLink, {
        [styles.active]: active,
        [styles.iconOnly]: iconOnly,
      })}
      onClick={onClose}>

      <Icon name={icon} />
      <p
        className={cn({
          [styles.hide]: iconOnly,
        })}
      >
        {name}
      </p>

    </Link>)
  );
};

export default NavLink;
